export const RequestStatus = Object.freeze({
  OPEN: 'OPEN',
  REJECTED: 'REJECTED',
  INSTALLED: 'INSTALLED'
});